module.exports = __webpack_public_path__ + "img/product-smoke-2.c037a30e.jpg";